<template>
  <div>
    <el-carousel height="58.75rem" width="100%">
      <el-carousel-item >
        <div class="">
          <p
            class="
              animated
              flash
              text-white
              h-28
              leading-28
              text-6xl text-cente
              box-border
              p-12
              mt-80
              font-black
              center
            "
          >
            {{ $t("home.title") }}
            <!-- {{item.name}} -->
            <!-- Pofessional provider of electrical  -->
          </p>
          <p
            class="
              text-white
              h-28
              leading-28
              text-6xl text-cente
              box-border
              p-12
              center
              font-black
            "
          >
            {{ $t("home.titleTow") }}
          </p>
        </div>
        <div class="w-full center">
          <router-link to="/solution">
            <p class="box-border text-white p-5 center w-60 h-12 home-font">
              {{ $t("home.viewSolutions") }}
              
            </p>
          </router-link>
        </div>
      </el-carousel-item>
       <el-carousel-item >
       <div class="">
          <p
            class="
              animated
              flash
              text-white
              h-28
              leading-28
              text-6xl text-cente
              box-border
              p-12
              mt-80
              font-black
              center
            "
          >
            {{ $t("home.weprovideq") }}
          </p>
          <p
            class="
              text-white
              h-28
              leading-28
              text-6xl text-cente
              box-border
              p-12
              center
              font-black
            "
          >
            {{ $t("home.weprovideTow") }}
          </p>
        </div>
        <div class="w-full center">
            <p class="box-border text-white p-5 center w-60 h-12 home-font" style="cursor: pointer" @click="goSolutions">
              {{ $t("home.viewSolutions") }}
            </p>
        </div>
      </el-carousel-item>
    </el-carousel>
    <div>
      <div class="mt-28 mb-20 max-w-75 m-auto">
        <div class="center text-4xl mb-9" style="color: #2b9868">
          {{ $t("home.ourService") }}
        </div>
        <div class="center text-lg" style="color: #">
          {{ $t("home.whatcan") }}
        </div>
      </div>
      <!--Our Service  -->
      <div
        class="
          grid
          2xl:grid-cols-3
          lg:grid-cols-1
          max-w-75
          box-content
          m-auto
          service
        "
      >
        <!-- 1 -->
        <div
          class="h-80 mr-7"
          style="border: 1px solid rgba(187, 208, 194, 0.4)"
        >
          <div class="flex justify-end">
            <div
              class="w-14 h-14 flex justify-center items-center font-semibold"
              style="
                background: #f9f9f9;
                color: #2b9868;
                font-family: 'NumFont';
                font-size: 20px;
              "
            >
              01
            </div>
          </div>
          <div class="box-border px-12">
            <div>
              <img src="../assets/home/iothardwareblack.png" alt="" />
              <hr
                style="
                  width: 20%;
                  background-color: green;
                  height: 0.125rem;
                  border: none;
                  margin-top: 1rem;
                "
              />
              <!-- <div class="home-lin"></div> -->
            </div>

            <div class="text-xl mb-4 mt-4" style="color: #333333">
              {{ $t("home.ioTHardware") }}
            </div>
            <div class="text-base mb-8 itemfont" style="color: #999999">
              {{ $t("home.focuson") }}
            </div>
            <hr />
          </div>
        </div>
        <!-- 2 -->
        <div
          class="h-80 mr-7"
          style="border: 1px solid rgba(187, 208, 194, 0.4)"
        >
          <div class="flex justify-end">
            <div
              class="w-14 h-14 flex justify-center items-center font-semibold"
              style="
                background: #f9f9f9;
                color: #2b9868;
                font-family: 'NumFont';
                font-size: 20px;
              "
            >
              02
            </div>
          </div>
          <div class="box-border px-12">
            <div>
              <img src="../assets/home/S&Pblack.png" alt="" />
              <hr
                style="
                  width: 20%;
                  background-color: green;
                  height: 0.125rem;
                  border: none;
                  margin-top: 1rem;
                "
              />
              <!-- <div class="home-lin"></div> -->
            </div>

            <div class="text-xl mb-4 mt-4" style="color: #333333">
              {{ $t("home.softwarePlatform") }}
            </div>
            <div class="text-base mb-8" style="color: #999999">
              {{ $t("home.webbased") }}
            </div>
            <hr />
          </div>
        </div>
        <!-- 3 -->
        <div
          class="h-80 mr-7"
          style="border: 1px solid rgba(187, 208, 194, 0.4)"
        >
          <div class="flex justify-end">
            <div
              class="w-14 h-14 flex justify-center items-center font-semibold"
              style="
                background: #f9f9f9;
                color: #2b9868;
                font-family: 'NumFont';
                font-size: 20px;
              "
            >
              03
            </div>
          </div>
          <div class="box-border px-12">
            <div>
              <img src="../assets/home/solutionblack.png" alt="" />
              <hr
                style="
                  width: 20%;
                  background-color: green;
                  height: 0.125rem;
                  border: none;
                  margin-top: 1rem;
                "
              />
              <!-- <div class="home-lin"></div> -->
            </div>

            <div class="text-xl mb-4 mt-4" style="color: #333333">
              {{ $t("home.solution") }}
              Solution
            </div>
            <div class="text-base mb-8" style="color: #999999">
              {{ $t("home.providesolutions") }}
            </div>
            <hr />
          </div>
        </div>
      </div>
      <!-- Our Advantages -->
      <div class="home-adcantages home-item">
        <div class="max-w-75 m-auto">
          <div class="">
            <div
              class="center"
              style="color: #fff; line-height: 8.625rem; font-size: 2.25rem"
            >
              {{ $t("home.ourAdvantages") }}
            </div>
            <div class="center text-lg text-white">
              {{ $t("home.whychoose") }}
            </div>
          </div>

          <div class="flex justify-around text-white mt-14">
            <div class="text-center mr-5 w-52">
              <p class="advanfont">
                <animate-number from="1" to="10" ref="myNum"></animate-number>+
              </p>
              <p class="mt-6 text-center">
                {{ $t("home.yearof") }}
              </p>
            </div>
            <div class="text-center w-52">
              <p class="advanfont">
                <animate-number from="1" to="40" ref="myNum"></animate-number>+
              </p>
              <p class="mt-6 text-center">
                {{ $t("home.servingcountries") }}
              </p>
            </div>
            <div class="text-center w-52">
              <p class="advanfont">
                <animate-number
                  from="1"
                  to="12000000"
                  ref="myNum"
                ></animate-number
                >+
              </p>
              <p class="mt-6 text-center">
                {{ $t("home.globalusers") }}
              </p>
            </div>
          </div>
          <div class="flex justify-around text-white mt-20">
            <div class="text-center w-52 mr-5">
              <p class="advanfont">
                <animate-number from="1" to="10" ref="myNum"></animate-number>+
              </p>
              <p class="mt-6 text-center" style="width: 13.5rem">
                {{ $t("home.servingFortune") }}
              </p>
            </div>
            <div class="text-center w-52 mr-5">
              <p class="advanfont w-52 text-center">
                <animate-number ref="myNum" from="1" to="40"></animate-number>+
              </p>
              <p class="mt-6 text-center">
                {{ $t("home.patents") }}
              </p>
            </div>
            <div class="text-center">
              <p class="advanfont w-52 text-center">
                <animate-number ref="myNum" from="1" to="40"></animate-number>+
              </p>
              <p class="mt-6 text-center">
                {{ $t("home.globalPartners") }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <!--Our Products  -->
      <div class="products max-w-75 m-auto">
        <div class="mt-32 mb-9">
          <div class="center text-4xl mb-9" style="color: #2b9868">
            {{ $t("home.ourProducts") }}
          </div>
          <div class="center text-lg" style="color: #666">
            {{ $t("home.werecommend") }}
          </div>
        </div>

        <div
          class="
            grid
            2xl:grid-cols-4
            xl:grid-cols-2
            max-w-75
            box-content
            m-auto
          "
          style="text-align: center"
        >
          <!-- 1 -->

          <div class="mr-4" style="border: 1px solid rgba(187, 208, 194, 0.4)">
            <div class="">
              <div class="flex center mt-14">
                <img
                  class="flex center w-44 h-44"
                  src="../assets/home/gateway.jpg"
                  alt=""
                />
              </div>
              <div class="">
                <div class="center px-7 leading-6 font-bold" style="">
                  {{ $t("home.gateway") }}
                </div>
                <div class="center">
                  <hr
                    class="center"
                    style="
                      width: 25%;
                      background-color: green;
                      height: 0.1rem;
                      border: none;
                      margin-top: 1rem;
                    "
                  />
                </div>

                <!-- <div class="home-lin"></div> -->
              </div>

              <div class="mt-6 leading-6 item px-7" style="color: #999">
                {{ $t("home.abrief") }}
              </div>

              <div class="center deta">
                <div
                  @click="details"
                  class="h-11 mb-9 mt-4 w-32 box-border center"
                  style="
                    color: #0a673e;
                    background-color: rgba(205, 222, 215, 0.4);
                  "
                >
                  {{ $t("home.details") }}
                </div>
              </div>
            </div>
          </div>
          <!-- 2 -->
          <div
            class="flex-1 mr-4"
            style="border: 1px solid rgba(187, 208, 194, 0.4)"
          >
            <div class="">
              <div class="flex center mt-14">
                <img
                  class="flex center w-44 h-44"
                  src="../assets/home/modular.jpg"
                  alt=""
                />
              </div>
              <div class="">
                <div class="center px-7 leading-6 font-bold">
                  {{ $t("home.module") }}
                </div>
                <div class="flex center">
                  <hr
                    class="center"
                    style="
                      width: 25%;
                      background-color: green;
                      height: 0.1rem;
                      border: none;
                      margin-top: 1rem;
                    "
                  />
                </div>

                <!-- <div class="home-lin"></div> -->
              </div>

              <div
                class="mt-6 box-border px-7 leading-6 item"
                style="color: #999"
              >
                {{ $t("home.abriefTow") }}
              </div>
              <div class="center deta">
                <div
                  @click="detailsTow"
                  class="h-11 mb-9 mt-4 w-32 box-border center"
                  style="
                    color: #0a673e;
                    background-color: rgba(205, 222, 215, 0.4);
                  "
                >
                  {{ $t("home.details") }}
                </div>
              </div>
            </div>
          </div>

          <!-- 3 -->
          <div
            class="flex-1 mr-4"
            style="border: 1px solid rgba(187, 208, 194, 0.4)"
          >
            <div class="">
              <div class="flex center mt-14">
                <img
                  class="flex center w-44 h-44"
                  src="../assets/home/parts.jpg"
                  alt=""
                />
              </div>
              <div class="">
                <div class="center px-7 leading-6 font-bold">
                  {{ $t("home.gateway") }}
                </div>
                <div class="flex center">
                  <hr
                    class="center"
                    style="
                      width: 25%;
                      background-color: green;
                      height: 0.1rem;
                      border: none;
                      margin-top: 1rem;
                    "
                  />
                </div>

                <!-- <div class="home-lin"></div> -->
              </div>

              <div
                class="mt-6 box-border px-7 leading-6 item"
                style="color: #999"
              >
                {{ $t("home.abriefThree") }}
              </div>
              <div class="center deta">
                <div
                  @click="detailsThree"
                  class="h-11 mb-5 mt-4 w-32 box-border center"
                  style="
                    color: #0a673e;
                    background-color: rgba(205, 222, 215, 0.4);
                  "
                >
                  {{ $t("home.details") }}
                </div>
              </div>
            </div>
          </div>
          <!-- 4 -->
          <div
            class="flex-1 mr-4"
            style="border: 1px solid rgba(187, 208, 194, 0.4)"
          >
            <div class="">
              <div class="flex center mt-14">
                <img
                  class="flex center w-44 h-44"
                  src="../assets/home/meter.jpg"
                  alt=""
                />
              </div>
              <div class="">
                <div class="center px-7 leading-6 font-bold">
                  {{ $t("home.electricMeter") }}
                </div>
                <div class="flex center">
                  <hr
                    class="center"
                    style="
                      width: 25%;
                      background-color: green;
                      height: 0.1rem;
                      border: none;
                      margin-top: 1rem;
                    "
                  />
                </div>

                <!-- <div class="home-lin"></div> -->
              </div>

              <div
                class="mt-6 box-border px-7 leading-6 item"
                style="color: #999"
              >
                {{ $t("home.abriefFour") }}
              </div>
              <div class="center deta">
                <div
                  @click="detailsFour"
                  class="h-11 mb-9 mt-4 w-32 box-border center"
                  style="
                    color: #0a673e;
                    background-color: rgba(205, 222, 215, 0.4);
                  "
                >
                  {{ $t("home.details") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="center mt-10 morestyle">
          <div
            @click="more"
            class="h-11 w-48 box-border center"
            style="color: #ffffff; background-color: #2b9868"
          >
            {{ $t("home.more") }}
          </div>
        </div>
      </div>
      <!-- Our Solutions -->
      <div
        class="flex justify-center solutions home-solutions max-w-80 m-auto"
        style="over-flow: hide"
      >
        <div class="grid grid-cols-9 w-full">
          <div
            class="
              home-oursolutions
              box-border
              p-14
              pt-40
              col-start-1 col-end-4
              text-white
            "
            style="background-color: #222222"
          >
            <div class="">
              <hr
                class="center"
                style="
                  width: 25%;
                  background-color: green;
                  height: 0.1rem;
                  border: none;
                "
              />
            </div>
            <p class="text-4xl mt-6 mb-10">
              {{ $t("home.ourSolutions") }}
            </p>
            <p>
              {{ $t("home.weprovide") }}
            </p>
            <div class="mt-10">
              <div
                class="h-11 w-48 box-border center"
                style="color: #ffffff; background-color: #2b9868"
              >
                <router-link to="/solution">
                  {{ $t("home.viewallSolution") }}
                </router-link>
              </div>
            </div>
          </div>
          <!-- 1 -->

          <div
            class="
              home-campus
              box-border
              relative
              col-start-4 col-end-6
              p-4
              text-white
            "
          >
            <div class="flex justify-end">
              <div
                class="w-14 h-14 flex justify-center items-center solu-font"
                style="background: #2b9868; color: #ffffff"
              >
                01
              </div>
            </div>

            <div class="absolute bottom-10">
              <div class="px-6 leading-6">
                <div>
                  <p class="text-xl font-semibold mb-4">
                    {{ $t("home.smartCampus") }}
                  </p>
                  <p>
                    {{ $t("home.basedon") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- 2 -->
          <div
            class="
              home-light
              box-border
              relative
              col-start-6 col-end-8
              p-4
              text-white
            "
          >
            <div class="flex justify-end">
              <div
                class="w-14 h-14 flex justify-center items-center solu-font"
                style="background: #2b9868; color: #ffffff"
              >
                02
              </div>
            </div>

            <div class="absolute bottom-10">
              <div class="px-6 leading-6">
                <div>
                  <p class="text-xl font-semibold mb-4">
                    {{ $t("home.smartStreetLight") }}
                  </p>
                  <p>
                    {{ $t("home.effectivelycontrol") }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- 3 -->
          <div
            class="
              home-ami
              box-border
              relative
              col-start-8 col-end-10
              p-4
              text-white
            "
          >
            <div class="flex justify-end">
              <div
                class="w-14 h-14 flex justify-center items-center solu-font"
                style="background: #2b9868; color: #ffffff"
              >
                03
              </div>
            </div>

            <div class="absolute bottom-10">
              <div class="px-6 leading-6">
                <div>
                  <p class="text-xl font-semibold mb-4">
                    {{ $t("home.ami") }}
                  </p>
                  <p class="break-normal itemfont">
                    {{ $t("home.anautomatic") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div
            class="home-ami box-border col-start-8 col-end-10 p-4 text-white"
          >
            <div class="flex justify-end">
              <div
                class="w-14 h-14 flex justify-center items-center solu-font"
                style="background: #2b9868; color: #ffffff"
              >
                03
              </div>
            </div>
            <div class="px-6">
              <p class="text-xl font-semibold mb-4" style="margin-top: 22.5rem">
                {{ $t("home.ami") }}
              </p>
              <p class="leading-6">
                {{ $t("home.anautomatic") }}
              </p>
             
            </div>
          </div> -->
        </div>
      </div>
      <!-- Our Partners -->
      <div class="xl:py-32 bg-f8 px-10 py-10 partners">
        <div class="max-w-75 box-content m-auto">
          <h1 class="text-4xl text-center mb-9" style="color: #2b9868">
            {{ $t("home.ourPartners") }}
          </h1>
          <p class="center mb-16 text-lg" style="color: #666666">
            {{ $t("home.clickon") }}
          </p>
          <div class="grid 2xl:grid-cols-3 grid-cols-2 gap-8">
            <a href="https://www.helium.com/" target="_blank">
              <div class="w-96 h-60 center bg-white">
                <img src="../assets/home/helium_logo.png" alt="" />
              </div>
            </a>

            <a href="https://www.heliumcat.com/" target="_blank">
              <div class="w-96 h-60 center bg-white">
                <img src="../assets/home/heliumcat_logo.png" alt="" />
              </div>
            </a>
            <a href="https://www.raspberrypi.com/" target="_blank">
              <div class="w-96 h-60 center bg-white">
                <img src="../assets/home/raspberryPi_logo.png" alt="" />
              </div>
            </a>
            <a href="https://www.semtech.com/" target="_blank">
              <div class="w-96 h-60 center bg-white">
                <img src="../assets/home/semtech_logo.png" alt="" />
              </div>
            </a>
            <a href="https://lora-alliance.org/" target="_blank">
              <div class="w-96 h-60 center bg-white">
                <img src="../assets/home/lora_logo.png" alt="" />
              </div>
            </a>
            <a href="https://www.dlms.com/" target="_blank">
              <div class="w-96 h-60 center bg-white">
                <img src="../assets/home/DlMS_logo.png" alt="" />
              </div>
            </a>
          </div>
        </div>
      </div>
      <!-- certification -->
      <div class="xl:py-32 px-10 py-10 max-w-75 box-content m-auto">
        <h1 class="text-4xl text-center mb-16 mt-10" style="color: #2b9868">
          {{ $t("about.certification") }}
        </h1>
        <img src="../assets/about/certification.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      // activeIndex: "1",
      url: "https://greenpalmiot.com/collections/pisces-gateway-hotspot",
      urlTow: "https://greenpalmiot.com/collections/lora-module",
      urlThree: "https://greenpalmiot.com/collections/antenna",
      urlFour:
        "https://greenpalmiot.com/products/lorawan%E5%AF%BC%E8%BD%A8%E8%A1%A8",
      urlMore: "https://greenpalmiot.com/",
      // carouselTitle:[
      //    { "name": '$t("about.certification")', "title": 100 }, 
      //    { "name": "华为手机", "title": 200 }, 
      // ]
      num:""
    };
  },
  computed: {},
  created() {},
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
  },
  watch: {},
  methods: {
    // handleScroll: function () {
    //       let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //       // 设备/屏幕高度
    //       let scrollObj = document.getElementById(div); // 滚动区域
    //       let scrollTop = scrollObj.scrollTop; // div 到头部的距离
    //       let scrollHeight = scrollObj.scrollHeight; // 滚动条的总高度
    //       //滚动条到底部的条件
    //       if(scrollTop+clientHeight == scrollHeight){
    //           // div 到头部的距离 + 屏幕高度 = 可滚动的总高度
    //       }
    // },
    // destroyed: function () {
    //   window.removeEventListener('scroll', this.handleScroll);   //  离开页面清除（移除）滚轮滚动事件
    // },
    goSolutions(){
      this.$router.push('/solution');
      this.num = 1
      window.localStorage.setItem('key', this.num)
      this.$store.commit('setSolutionActive', this.num)

    },
    details() {
      window.open(this.url, "_blank");
      // window.location.href = this.url;
    },
    detailsTow() {
      window.open(this.urlTow, "_blank");
      // window.location.href = this.urlTow;
    },
    detailsThree() {
      window.open(this.urlThree, "_blank");
      // window.location.href = this.urlThree;
    },
    detailsFour() {
      window.open(this.urlFour, "_blank");
      // window.location.href = this.urlFour;
    },
    more() {
      window.open(this.urlMore, "_blank");
      // window.location.href = this.urlMore;
    }
  }
};
</script>

<style scoped lang="less">
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    -ms-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
}
.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
}
.products {
  .item {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .deta :hover {
    cursor: pointer;
  }
  .morestyle :hover {
    cursor: pointer;
  }
}
.home-solutions {
  height: 35rem;
  margin-top: 7.56rem;
  overflow: hidden;
  .solu-font {
    font-family: "NumFont";
    font-size: 1.125rem;
  }
  .home-oursolutions {
    background: url("../assets/home/solution0101010101.png") no-repeat;
    background-size: 100%;
    background-size: cover;
  }
  .home-campus {
    background: url("../assets/home/smartcampus.jpg") no-repeat;
    background-size: 100%;
    background-size: cover;
  }
  .home-light {
    background: url("../assets/home/smartstreetlight.jpg") no-repeat;
    background-size: 100%;
    background-size: cover;
  }
  .home-ami {
    background: url("../assets/home/AMI.jpg") no-repeat;
    background-size: 100%;
    background-size: cover;
  }
}

.home-font {
  margin-top: 10rem;
  background-color: #2b9868;
}
.home-adcantages {
  margin-top: 7.5rem;
  height: 33.75rem;
  .advanfont {
    font-family: "NumFont";
    font-size: 2.25rem;
  }
}

.home-item {
  background: url("../assets/home/advantage.jpg") no-repeat;
  background-size: 100%;
  background-size: cover;
}
.el-carousel__item h3 {
  background: url("../assets/home/banner1.jpg") no-repeat;
  background-size: 100%;
  background-size: cover;
  opacity: 0.75;
  line-height: 58.75rem;
  margin: 0;
}
/deep/.el-carousel__arrow i {
  font-size: 2rem !important;
  border-radius: 1rem;
  // background-color: rgba(0, 0, 0, 0.2);
}
.el-carousel__item:nth-child(2n) {
  background: url("../assets/home/5G.jpg") no-repeat;
  background-size: 100%;
  background-size: cover;
}

.el-carousel__item:nth-child(2n + 1) {
  background: url("../assets/home/banner1.jpg") no-repeat;
  background-size: 100%;
  background-size: cover;
}
/deep/ .el-carousel__indicators {
  // 指示器
  // left: unset;
  // transform: unset;
  // right: 2%;
  bottom: 10%;
}
/deep/ .el-carousel__button {
  // 指示器按钮
  width: 10px;
  height: 10px;
  border: none;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.2);
}

.bgline {
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.001),
    rgba(0, 0, 0, 0.6)
  );
}
.service {
  .itemfont {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.solutions {
  .itemfont {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}

.partners {
  background: url("../assets/home/partner_bg.jpg") no-repeat;
  background-size: 100%;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue